import React, { Component, Fragment } from 'react';
import './WorkshopCard.Module.scss';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBolt, faChevronLeft, faCode, faHeart, faUsers, faUser, faClock } from '@fortawesome/pro-solid-svg-icons';

import {faHeart as faHeartRegular} from '@fortawesome/pro-regular-svg-icons';
import HeartButton from '../HeartButton/HeartButton';


class WorkshopCard extends Component {

    render() {

        return (
        <Fragment>
            <div styleName='card-wrapper'>
                <div styleName='background-image' style={{backgroundImage: `url(images/card/het-spel-zonder-regels.jpg)`}}>
                </div>
                <div styleName='content-wrapper'>
                    <h1>HET SPEL ZONDER REGELS</h1>
                    <h3>Technisch</h3>
                    <div styleName='technisch-bar'>
                        <div styleName='technisch-bar-content'>
                        
                        </div>
                    </div>
                    <h3>Creatief</h3>
                    <div styleName='creative-bar'>
                        <div styleName='creative-bar-content'>
                        
                        </div>
                    </div>
                    <h3>Filosofisch</h3>
                    <div styleName='filosofisch-bar'>
                        <div styleName='filosofisch-bar-content'>
                        
                        </div>
                    </div>
                    <div styleName='label-wrapper'>
                        <HeartButton/>
                        <p>Scratch</p>
                        <p>Processing</p>
                        <p>+2</p>
                    </div>
                    <div styleName='icon-wrapper'>
                        <div styleName='icons-left'>
                            <div styleName='circle'>
                                <div styleName='icon'>
                                <FontAwesomeIcon icon={faBolt}/>
                                </div>
                            </div>
                            <div styleName='circle'>
                                <div styleName='icon'>
                                <FontAwesomeIcon icon={faUsers}/>
                                </div>
                            </div>
                            <div styleName='circle'>
                                <div styleName='icon'>
                                <FontAwesomeIcon icon={faUser}/>
                                </div>
                            </div>
                            <div styleName='circle'>
                                <div styleName='icon'>
                                <p>
                                    <FontAwesomeIcon icon={faClock} />  15 - 120 min
                                </p>
                                </div>
                            </div>
                        </div>
                        <div styleName='icons-right'>
                            <div styleName='circle'>
                                <div styleName='icon'>
                                    <HeartButton/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
        );
    }
}

export default WorkshopCard;